import { ref } from "vue";

// Сколько пикселей снизу карты (на мобильном) занято нижними шторками -
// маршрута (MobileRouteDetailSheet.vue) или панелью поиска над таб-баром
// (MobileMapOverlay.vue). Шторка публикует сюда свою текущую высоту (в том
// числе в такт перетаскиванию), MapView.vue кладёт значение в CSS-переменную
// --map-sheet-inset, а тулбар карты на мобильном якорится над этим отступом.
// Одна общая ref, а не prop/emit через App.vue: шторки и карта - соседи в
// App.vue, и обоим нужен только этот единственный скаляр.
export const mapSheetInset = ref(0);

// Кто сейчас владеет значением. Шторка размонтируется - снимает отступ, только
// если он всё ещё её: новая шторка (список -> маршрут, точка закрылась поверх
// маршрута) могла уже выставить своё - в том числе ровно ту же высоту, поэтому
// сравнивается владелец, а не число.
let insetOwner: unknown = null;
export const publishMapSheetInset = (owner: unknown, px: number) => {
  insetOwner = owner;
  mapSheetInset.value = px;
};
export const releaseMapSheetInset = (owner: unknown) => {
  if (insetOwner !== owner) return;
  insetOwner = null;
  mapSheetInset.value = 0;
};

// Сколько снизу закрыто целиком - для camera-отступов поиска (flyTo/fitBounds).
// Сейчас совпадает с mapSheetInset (панель поиска в покое - единственное, что
// закрывает карту снизу; развёрнутый поиск закрывает её всю).
export const mapSheetCover = ref(0);
